import React, { type ComponentProps } from 'react';

import { clsx } from 'clsx';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';

type Props = {
  isActive?: boolean;
} & ComponentProps<typeof ExtendedLink>;

export function NavigationLink({
  className,
  isActive = false,
  ...rest
}: Props) {
  const conditionalStyles = {
    [styles['navigationLink--active']]: isActive,
  };

  return (
    <ExtendedLink
      className={clsx(styles.navigationLink, conditionalStyles, className)}
      {...rest}
    />
  );
}
